// removed by extract-text-webpack-plugin
module.exports = {"wasabi-searchbar":"wasabi-searchbar","leftform":"leftform","rightbutton":"rightbutton","wasabi-searchbar-down":"wasabi-searchbar-down","wasabi-searchbar-up":"wasabi-searchbar-up"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Form/SearchBar.scss
// module id = 237
// module chunks = 0